import {
  withTranslation,
} from 'react-i18next';

import RegattaResultTableRaceSelectorSectionView from './RegattaResultTableRaceSelectorSectionView';

const TranslatedComponent = withTranslation()(RegattaResultTableRaceSelectorSectionView);

const Component = TranslatedComponent;

export default Component;
